import {ServerListData} from "../../modules/core/data/ListData";

export const useIsTableEmpty = (d: ServerListData<any, any>) => {
    return d.ready && d.data?.getItemsList()?.length > 0;
}